exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-box[data-v-2fba31bc]{position:relative}", ""]);

// exports
